import React, { useContext, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from 'i/icons/close_thin.svg';
import { UiContext } from 'context/ui';
import { generateUniqueId, formatNumberToFixed } from 'utils';
import InfoBox from 'components/GlassProduct/InfoBox';
import GlassConfigTableRowCell from './GlassConfigTableRowCell';
import GlassConfigTableRowNotesCell from './GlassConfigTableRowNotesCell';

const GlassConfigTableRow = ({
	value,
	configurationData,
	freezerRef,
	activeInputRowCellRef,
	glassTypeId,
	rowId,
	displayPosition,
	showPrice,
	isPreview = false,
}) => {
	const { t } = useTranslation('configurationTableHeading');
	const cellRefs = useRef([]);
	const { showPopupByKey } = useContext(UiContext);
	const glassIndex = configurationData.glassTypes.findIndex(o => o.id === glassTypeId);
	const posIndex = configurationData.glassTypes[glassIndex].positions.findIndex(
		o => o.id === rowId
	);
	const { totals } = configurationData;
	const total = totals.totalGlassSizes[glassIndex][posIndex] || {};
	const { priceVolumeCat } = totals.totalGlassSizesSum;

	cellRefs.current = Array(value.row.length)
		.fill()
		.map(() => React.createRef());

	const showDeletePositionPopup = () => {
		showPopupByKey('deletePosition', {
			confirmDialog: isConfirmed => {
				if (isConfirmed) freezerRef.current.emit('removePosition', { glassTypeId, rowId });
			},
		});
	};

	const notesIndex = 5;
	/*
	const notesIndex = useMemo(() => {
		return value.row.findIndex(e => e.name === 'notes');
	}, [value.row]);
	*/
	const filteredRow = value.row.filter(e => e.name !== 'notes');
	const formElementIdRef = useRef(generateUniqueId(22));

	const p =
		showPrice &&
		configurationData.totals.totalGlassSizes[glassIndex][posIndex]?.prices?.[priceVolumeCat];
	const displayPrice = showPrice ? formatNumberToFixed(p || '-', 2, t('i18n:numberFormat')) : '-';
	const inactive =
		value.inactive && !value.row[0].value && !value.row[1].value && !value.row[2].value;

	return (
		<>
			<li
				className={classNames('glass_config_table__row glass_config_table__row1', {
					'glass_config_table__row--inactive_mod': inactive,
				})}
			>
				{displayPosition ? (
					<div className="glass_config_table__cell glass_config_table__position_idx">
						{displayPosition}
					</div>
				) : null}
				{filteredRow?.length ? (
					<>
						{filteredRow.map((cellItem, index) => (
							<GlassConfigTableRowCell
								key={cellItem.name}
								ref={cellRefs.current[index]}
								freezerRef={freezerRef}
								activeInputRowCellRef={activeInputRowCellRef}
								glassTypeId={glassTypeId}
								cellRefs={cellRefs}
								cellIndex={index}
								cellData={cellItem}
								formElementIdRef={formElementIdRef}
								isPreview={isPreview}
								rowId={rowId}
								configurationData={configurationData}
							/>
						))}
						<div className="glass_config_table__cell glass_config_table__cell--size_state">
							{formatNumberToFixed(total.m2Pc, 2, t('i18n:numberFormat'))}
						</div>
						<div className="glass_config_table__cell glass_config_table__cell--size_state">
							{formatNumberToFixed(total.m2, 2, t('i18n:numberFormat'))}
						</div>
						<div className="glass_config_table__cell glass_config_table__cell--size_state">
							{formatNumberToFixed(total.kg, 0, t('i18n:numberFormat'))}
						</div>
						<div className="glass_config_table__cell glass_config_table__cell--size_state">
							{showPrice ? (
								displayPrice
							) : (
								<InfoBox
									hoverMessage={t('registrationForm:registerForPrices')}
									iconClassName="icon_mod_inplace"
								/>
							)}
						</div>
					</>
				) : null}
				<button
					className="glass_config_table__btn_remove_row"
					type="button"
					onClick={e => {
						e.stopPropagation();
						showDeletePositionPopup();
					}}
				>
					<CloseIcon className="icon icon-close_thin size_mod" />
				</button>
			</li>
			<li
				className={classNames('glass_config_table__row glass_config_table__row2', {
					'glass_config_table__row--inactive_mod': inactive,
				})}
			>
				<div className="glass_config_table__cell_title glass_config_table__notes_hdr glass_config_table__cell_title--offset_mod">
					{t('notes')}
				</div>
				<GlassConfigTableRowNotesCell
					ref={cellRefs.current[notesIndex]}
					key={notesIndex}
					freezerRef={freezerRef}
					glassTypeId={glassTypeId}
					cellIndex={notesIndex}
					cellData={value.row[notesIndex]}
					cellRefs={cellRefs}
					rowId={rowId}
					formElementIdRef={formElementIdRef}
				/>
			</li>
		</>
	);
};

export default GlassConfigTableRow;
